/*
 * @Author: chenting chenting@cqliving.com
 * @Date: 2022-09-05 09:12:37
 * @LastEditors: chenting chenting@cqliving.com
 * @LastEditTime: 2022-09-15 11:06:17
 * @FilePath: \share-news-detail-pages\src\api\newchongqing\index.ts
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import Api from "@/api/index";
import request from "@/common/request";
import { IShijiaArticleDetailRes } from "./types";
class NewChongQing extends Api {
  public async infoDetailNewSijia(params: {
    infoClassifyId: string;
    token: string;
  }): Promise<IShijiaArticleDetailRes | any> {
    let res;
    try {
      const res1 = await request.get(
        process.env.VUE_APP_BASE_JSON +
          `/app/news/infoDetailNew/${params.infoClassifyId}.json`
      );
      res = {
        code: 0,
        data: res1
      };
    } catch (error) {
      res = await request.post("/infoDetailNew.html", {
        infoClassifyId: params.infoClassifyId,
        token: params.token
      });
    }
    return res;
  }
  getInfoDetailshiJiaPeople(params: {
    columnsId: string;
    token: string;
  }): Promise<any> {
    return request.post("/infoDetailNewMingJia.html", {
      columnsId: params.columnsId,
      token: params.token
    });
  }
  follow(params: {
    appId: string;
    infoId: string;
    token: string;
    status: string;
    type: string;
  }): Promise<any> {
    return request.post("/sj/follow.html", {
      appId: params.appId,
      infoId: params.infoId,
      token: params.token,
      status: params.status,
      type: params.type
    });
  }
  getPosterShareData(params: { infoClassifyId: string }): Promise<any> {
    return request.post("getPosterShareData.html", {
      infoClassifyId: params.infoClassifyId
    });
  }
  getDefaultConfig(propId: string): Promise<any> {
    return request.get(
      "http://121.199.78.162:30031/prop-data-detail/getDefaultDataByPropId?propId=" +
        propId
    );
  }
  // /getNotFoundUrl  404
  getNotFoundUrl(params: {
    sourceId: string;
    sourceType: string;
  }): Promise<any> {
    return request.get("/getNotFoundUrl.html", {
      params: {
        sourceId: params.sourceId,
        sourceType: params.sourceType
      }
    });
  }
}
export default new NewChongQing();
